module.exports = __webpack_public_path__ + "img/07_1440x816.3729bdd7.png";